import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";

export interface MenuButtonProps {
  onClick: () => void;
  /** `true` mientras el panel del menú está abierto. */
  expanded: boolean;
  /** id del panel que abre, para enlazarlo con `aria-controls`. */
  controls: string;
}

/**
 * La píldora "Menú" de la barra superior.
 *
 * `aria-expanded` + `aria-controls` son lo que convierte a este botón en
 * un disparador de menú para un lector de pantalla; sin ellos se anuncia
 * como un botón cualquiera y nadie sabe que algo se abrió.
 */
export function MenuButton({ onClick, expanded, controls }: MenuButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      aria-expanded={expanded}
      aria-controls={controls}
      leftIcon={<Menu />}
      className="bg-white uppercase tracking-ds-label"
    >
      {t("Menú")}
    </Button>
  );
}
